import React from 'react';
import { CheckIcon, LockIcon, PlayCircleIcon, UsersIcon } from 'lucide-react';
import { pricing } from '../data/masterclass';
export function Pricing() {
  return <section aria-labelledby="pricing-heading" className="border-t border-ink-line bg-ink" id="pricing" data-id="element-110" data-mp="2oipkb1geh7h0">
      <div className="mx-auto w-full max-w-5xl px-6 py-20 lg:py-28" data-id="element-111" data-mp="2jjcm5kk2wdz4">
        <div className="text-center" data-id="element-112" data-mp="1vu1way49o3zr">
          <p className="text-[11px] font-bold uppercase tracking-overline text-gold" data-id="element-113" data-mp="1vv350vxt8eeb">
            Investment
          </p>
          <h2 id="pricing-heading" className="mt-4 font-display text-4xl font-bold uppercase text-white sm:text-5xl" data-id="element-114" data-mp="1ru184lrd8efi">
            Choose your experience
          </h2>
        </div>

        <div className="mt-14 grid items-stretch gap-6 sm:grid-cols-2" data-id="element-115" data-mp="20v7psy5r3vac">
          {pricing.map(tier => <div key={tier.name} className={`flex flex-col rounded-2xl border p-8 ${tier.featured ? 'border-gold bg-gold/[0.06]' : 'border-ink-line bg-ink-soft'}`} data-id="element-116" data-mp="3h97ne2h4j8uf">
              <div className="flex items-start justify-between gap-3" data-id="element-117" data-mp="4rb0tz2hlhuh">
                <h3 className="font-display text-xl font-semibold uppercase leading-tight text-white" data-id="element-118" data-mp="9ta5dc9yqkt0">
                  {tier.name}
                </h3>
                {tier.featured && <span className="shrink-0 rounded-full bg-gold px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-ink" data-id="element-119" data-mp="3d9qq2gvg3evc">
                    Complete plan
                  </span>}
              </div>

              <div className="mt-6 flex items-end gap-2" data-id="element-120" data-mp="3n5tzm7smmfsb">
                <span className="font-display text-6xl font-bold leading-none text-gold" data-id="element-121" data-mp="3ry3l9bmpktos">
                  {tier.price}
                </span>
                <span className="pb-1 text-sm uppercase tracking-[0.12em] text-white/50" data-id="element-122" data-mp="2ui7ngb5c22tu">
                  {tier.unit}
                </span>
              </div>

              <p className="mt-4 max-w-[46ch] leading-[1.7] text-white/60" data-id="element-123" data-mp="2rftcca3hjhf4">
                {tier.description}
              </p>

              <ul className="mb-8 mt-6 space-y-3" data-id="element-124" data-mp="2mhi3o2oxfcyh">
                {tier.perks.map(perk => <li key={perk} className="flex items-start gap-3 leading-relaxed text-white/75" data-id="element-125" data-mp="315wfv488gdrp">
                    <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-126" data-mp="2w8d1m4bjc0zr" />
                    <span data-id="element-127" data-mp="23jpc1wjr6pge">{perk}</span>
                  </li>)}
              </ul>

              <a href={tier.url} target="_blank" rel="noopener noreferrer" className={`mt-auto inline-flex items-center justify-center rounded-full px-7 py-5 text-center text-sm font-bold uppercase tracking-[0.12em] transition-[transform,background-color,color] duration-200 ease-out active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold ${tier.featured ? 'bg-gold text-ink hover:bg-gold-pale' : 'border border-gold text-gold hover:bg-gold hover:text-ink'}`} data-id="element-128" data-mp="2iggd0a92s984">
                {tier.cta}
              </a>
            </div>)}
        </div>

        <ul className="mt-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm text-white/55" data-id="element-129" data-mp="j0v7uedb9uwg">
          {[{
          Icon: LockIcon,
          label: 'Secure checkout'
        }, {
          Icon: UsersIcon,
          label: 'One price covers both of you'
        }, {
          Icon: PlayCircleIcon,
          label: 'Replay if you can’t attend live'
        }].map(({
          Icon,
          label
        }) => <li key={label} className="flex items-center gap-2" data-id="element-130" data-mp="e823vspo2qlf">
              <Icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-131" data-mp="11yxskgytt5og" />
              {label}
            </li>)}
        </ul>

        <p className="mt-6 text-center text-sm text-white/40" data-id="element-132" data-mp="16sk94k841tpj">
          After payment, your Zoom registration and workbook are emailed to you.
        </p>
      </div>
    </section>;
}